import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./Logo";

// Handles the Emergent Google OAuth redirect callback.
export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/admin");
        return;
      }
      try {
        const res = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(res.data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: res.data } });
      } catch (e) {
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { authError: true } });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-paper">
      <div className="mb-4">
        <Logo className="h-8" />
      </div>
      <p className="font-sans text-ink/50 text-sm animate-pulse">Signing you in…</p>
    </div>
  );
};
